import { useMutation } from "@apollo/client";

import { gql } from "@medbillai/generated-graphql-types";

import { errorHandling } from "../lib/apollo/utils";
import { getIssueQuery } from "../screens/case/utils/queries";
import { getMostRecentClosedIssueWithoutFeedbackQuery } from "../screens/home/utils/queries";

const createIssueFeedbackMutation = gql(/* GraphQL */ `
  mutation CreateIssueFeedback($input: CreateIssueFeedbackInput!) {
    createIssueFeedback(input: $input) {
      success
    }
  }
`);

// The backend stitches this feedback to the most recent ClosedEvent for the
// issue that doesn't already have feedback (feedback.service.ts → createUserIssueFeedback),
// so callers only pass the rating/review — not which event it belongs to.
export function useCreateIssueFeedback() {
  return useMutation(createIssueFeedbackMutation, {
    context: errorHandling("error-screen"),
    refetchQueries: [
      getMostRecentClosedIssueWithoutFeedbackQuery,
      getIssueQuery,
    ],
  });
}
